/**
 * Online-Arena eligibility helpers — shared by the trusted callables (which
 * hard-gate) and the portal (which hides the affordance). ONE source of truth
 * for "can this version honor an invite".
 */

/**
 * The @djgg/creation-shell version that first reads the `?match=` pairing key
 * (host.ts). A bundle built against an older shell silently ignores the token
 * and would pair non-deterministically through the public quick-match pool, so
 * Arena host/accept is gated on the PLAYED version's baked `shellVersion` being
 * at least this. Bump this in lockstep only if the pairing contract itself
 * changes.
 */
export const ONLINE_INVITE_MIN_SHELL = '0.8.0';

/** Compare two dotted numeric versions (major.minor.patch); missing parts = 0. */
function compareVersion(a: string, b: string): number {
  const pa = a.split('.').map((n) => Number.parseInt(n, 10) || 0);
  const pb = b.split('.').map((n) => Number.parseInt(n, 10) || 0);
  for (let i = 0; i < 3; i += 1) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d !== 0) return d;
  }
  return 0;
}

/**
 * True when a version's baked shell can honor an Arena invite's `?match=` token
 * ({@link ONLINE_INVITE_MIN_SHELL} or newer). Absent shellVersion (pre-shell
 * bundles) is NOT eligible.
 */
export function supportsOnlineInvites(shellVersion: string | undefined): boolean {
  if (!shellVersion) return false;
  return compareVersion(shellVersion, ONLINE_INVITE_MIN_SHELL) >= 0;
}
